export const CREATE_EMAIL_1 = 'create-email-1';